import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IBookmarkRepository } from '../../repositories/interfaces/iBookmarkRepository';
import { IBookMarkSearchParams } from '../../../entity/interface/iBookmark';

export interface IGetDetailBookmarkUseCase {
    execute(
        apiKey: string,
        profileGuid: string,
        token: string,
        identityToken: string,
        searchParams: IBookMarkSearchParams,
        datasource?: string
    ): Promise<any>;
}

export class GetDetailBookmarkUseCase implements IGetDetailBookmarkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getDetailBookmark(): IBookmarkRepository {
        return container.resolve<IBookmarkRepository>(DI.REPOSITORIES.IBookmarkRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        apiKey: string,
        profileGuid: string,
        token: string,
        identityToken: string,
        searchParams: IBookMarkSearchParams,
        datasource?: string
    ): Promise<any> {
        return await this.getDetailBookmark.getDetailBookmark(
            apiKey,
            profileGuid,
            token,
            identityToken,
            searchParams,
            datasource
        );
    }
}
